import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { teamShape, practiceShape } from '../prop-types'
import SelectTeam from './SelectTeam'

const useStyles = createUseStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  name: {
    fontWeight: 600,
    fontSize: 15,
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  // The team picker is this row's only control. On desktop it shares the row
  // with the name; on the card it gets the full width so the selected tags are
  // readable instead of being squeezed into half a phone screen.
  control: {
    marginTop: 4,
  },
})

// Both desktop columns fit on the card, so these rows need no expand toggle.
export default function PracticeMobileCard({ practice, teams }) {
  const classes = useStyles()

  return (
    <div className={classes.card}>
      <div className={classes.name}>{practice.name || '—'}</div>
      <div className={classes.control}>
        <SelectTeam practice={practice} teams={teams} width="100%" />
      </div>
    </div>
  )
}

PracticeMobileCard.propTypes = {
  practice: practiceShape.isRequired,
  teams: PropTypes.arrayOf(teamShape).isRequired,
}
